export enum WebhookType {
	WEBHOOK_ALL_QUALIFIED_LEADS = "WEBHOOK_ALL_QUALIFIED_LEADS",
	WEBHOOK_ALL_LEADS = "WEBHOOK_ALL_LEADS",
	WEBHOOK_ALL_LEADS_INCLUDING_NOT_FOUND = "WEBHOOK_ALL_LEADS_INCLUDING_NOT_FOUND",
	WEBHOOK_WHEN_ASSIGNED = "WEBHOOK_WHEN_ASSIGNED",
	WEBHOOK_WHEN_REPLIED = "WEBHOOK_WHEN_REPLIED",
}
